import React, { useEffect } from "react";
import { useLocation } from "react-router-dom";
import Header from "./Header";
import Hero from "./Hero";
import OurStorySection from "./OurStorySection";
import ProductsAndIngredientsSection from "./ProductsAndIngredientsSection";
import ComingSoonSection from "./ComingSoonSection";
import ReviewsSection from "./ReviewsSection";
import FAQSection from "./FAQSection";
import ContactSection from "./ContactSection";
import NewsletterSection from "./NewsletterSection";
import Footer from "./Footer";

const HomePage = () => {
  const location = useLocation();

  useEffect(() => {
    if (location.hash) {
      const id = location.hash.slice(1);
      const el = document.getElementById(id);
      if (el) {
        // Give the page a tick to paint before scrolling
        requestAnimationFrame(() => el.scrollIntoView({ behavior: "smooth" }));
      }
    }
  }, [location]);

  return (
    <div className="homepage">
      <Header />
      <Hero />
      <ProductsAndIngredientsSection />
      <ComingSoonSection />
      <ReviewsSection />
      <FAQSection />
      <ContactSection />
      <OurStorySection />
      <NewsletterSection />
      <Footer />
    </div>
  );
};

export default HomePage;
